<template>
  <b-overlay :show="languageBusy">
    <portlet title="تىل ئۇچۇرى تەھرىرلەش">
      <template v-slot:body>
        <language-form
          ref="language"
          action="edit"
          :model-id="languageId"
          @loading="onLoading"
          @loaded="onLoaded"
          @updating="onLoading"
          @updated="onUpdated"
        />
      </template>
      <template v-slot:foot>
        <b-button id="submit" @click="handleSubmit" variant="primary">
          ساقلاش
        </b-button>
        <b-button class="ml-2" variant="danger" @click="onClickReset">
          بىكار قىلىش
        </b-button>
      </template>
    </portlet>
  </b-overlay>
</template>

<script>
  import Portlet from "@v@/partials/content/Portlet";
  import LanguageForm from "@v@/components/forms/LanguageForm";
  import BreadCrumbs from "@c@/breadcrumbs.service";
  import formBusyMixin from "@m@/common/formBusy.mixin";
  import sweetAlertMixin from "@m@/common/sweetAlert.mixin";
  import { debugConsole } from "@c@/helpers/helpers";
  export default {
    name: "index",
    components: { Portlet, LanguageForm },
    mixins: [ formBusyMixin, sweetAlertMixin ],
    mounted() {
      BreadCrumbs.setBreadCrumb([]);
      BreadCrumbs.addBreadCrumb({title: 'تىل باشقۇرۇش', route: {name: 'language.home'}});
      BreadCrumbs.addBreadCrumb({title: 'تىل ئۇچۇرى تەھرىرلەش'});
      if ( this.$refs.hasOwnProperty('language') ){
        this.form = this.$refs['language'];
      }
    },
    computed: {
      languageId(){
        if ( this.$route.hasOwnProperty('params') )
          return this.$route.params.id;
      },
    },
    data(){
      return {
        languageBusy: false,
        form: {}
      };
    },
    methods: {
      handleSubmit(){
        this.form.onSubmit();
      },
      onLoading(){
        this.showBusy('languageBusy');
        debugConsole({prefix: 'language', message: 'onLoading'})
      },
      onLoaded({response, state}){
        this.hideBusy('languageBusy');
        debugConsole({prefix: 'language', message: `onLoaded: ${state}`});
      },
      onUpdated({response, state}){
        this.hideBusy('languageBusy');
        debugConsole({prefix: 'language', message: `onUpdated: ${state}`});
        if ( state === 'success' ){
          this.success({ message: 'تىل ئۇچۇرى تەھرىرلەش مۇۋاپىقىيەتلىك بولدى.' });
        }
      },
      onClickReset(){
        this.$router.replace({name: 'language.home'});
      },
    }
  }
</script>

<style scoped>

</style>
